import * as phone from 'libphonenumber-js/max'
import * as yup from 'yup'

import { t } from '@owl-nest/localize'

function isValidPhone(value?: string): boolean {
  if (value === undefined) {
    return false
  }

  try {
    const number = phone.parsePhoneNumber(value)
    return number.isValid()
  } catch (error) {
    return false
  }
}

export function phoneNumber(length = 15): yup.StringSchema {
  return yup
    .string()
    .max(
      length,
      t('Your phone number cannot be more than %(length)d digits', {
        length: length,
      }),
    )
    .test('isValidPhone', t('Phone number is invalid'), isValidPhone)
}
